import NotFound from 'common/NotFound';
import useDebounce from 'common/UseDebounce';
import useFullPageLoader from 'common/UseFullPageLoader';
import { SearchBar } from 'components/form';
import React, { useEffect, useState } from 'react'
import { FaEdit, FaRegTrashAlt, FaToggleOff, FaToggleOn } from 'react-icons/fa';
import { useSearchParams } from 'react-router-dom';
import { subSubCategoryListApi } from 'services/subCategory';
import findSerialNumber from 'utils/findSerialNumber';
import UpdateSubSubCategory from './UpdateSubSubCategory';
import Pagination from 'react-js-pagination';
import ChangeStatusSubSubCategory from './ChangeStatusSubSubCategory';
import DeleteSubSubCategory from './DeleteSubSubCategory';

const SubSubCategoryList = () => {
    const [loader, onShow, onHide] = useFullPageLoader();
    const [subSubCategory, setSubSubCategory] = useState([])

    const [searchParams, setSearchParams] = useSearchParams();
    const [search, setSearch] = useState("");
    const debouncedValue = useDebounce(search, 300);
    const [total, setTotal] = useState(null);
    const activePage = +searchParams.get("page") || 1;
    const limit = +searchParams.get("limit") || 10;
    const [categoryModal, setCategoryModal] = useState({ modal: false })
    const [changeStatusModal, setChangeStatusModal] = useState({ modal: false })
    const [deleteModal, setDeleteModal] = useState({ modal: false })
    console.log({ total, subSubCategory })
    // ------------Add---Update-modal----------------------------
    const handleUpdateCategory = (data, type) => {
        setCategoryModal({ ...data, type, modal: true })
    }
    // ------------change-status-modal----------------------------
    const handleChangeStatus = (data) => {
        setChangeStatusModal({ ...data, modal: true })
    }
    // ------------delete-modal----------------------------
    const handleDeleteModal = (data) => {
        setDeleteModal({ ...data, modal: true })
    }
    // ---------handle-page---------------
    const handlePageChange = (event) => {
        searchParams.set("page", event);
        setSearchParams(searchParams);
    };

    // --------sub-sub-list-----------------
    const fetchSubSubCategory = async () => {
        try {
            onShow();
            const query = {
                page: activePage,
                limit: limit,
            };
            if (search && debouncedValue) {
                query.search = debouncedValue;
            }

            const res = await subSubCategoryListApi(query);
            if (res?.data?.code === 200) {
                // console.log('res', res?.data)
                setSubSubCategory(res?.data?.data?.data || []);
                setTotal(res?.data?.data?.total);
            }
        } catch (error) {
            console.log("Cat Data fetch error:---> ", error);
        } finally {
            onHide();
        }
    };

    useEffect(() => {
        fetchSubSubCategory()
    }, [debouncedValue, activePage, limit])

    useEffect(() => {
        if (activePage == 1) {
            searchParams.delete('page')
        }
        if (!search) {
            searchParams.delete('search')
        }
        setSearchParams(searchParams)
    }, [activePage, debouncedValue])
    return (
        <>
            <div className="page_title">
                <h3>Sub Category Management</h3>
            </div>
            <div className="card">
                {loader}

                <div className="search-add-cat">
                    <div className="search_wrapper">
                        <SearchBar
                            placeholder={"Search..."}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                const searchIns = new URLSearchParams(searchParams);
                                searchIns.set("page", 1);
                                setSearchParams(searchIns);
                            }}
                            value={search}
                        />
                    </div>
                    <div>
                        <button
                            className="button"
                            onClick={() => handleUpdateCategory(null, 'Add')}
                        >
                            Add Filter Category
                        </button>
                    </div>
                </div>

                {/* ------- menu header-------- */}

                <div className="table-container">
                    <table className="table custom_table">
                        <thead>
                            <tr>
                                <th className="nowrap text-center">S.No</th>
                                <th className="nowrap text-center">Name</th>
                                <th className="nowrap text-center">Sub Category Name</th>
                                <th className="nowrap text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {subSubCategory && subSubCategory.length ? (
                                subSubCategory?.map((data, index) => {
                                    // console.log(data?.image);
                                    return (
                                        <tr key={index}>
                                            <td className="nowrap text-center">
                                                {findSerialNumber(index, activePage, limit)}
                                            </td>
                                            <td className="nowrap text-center">{data?.name}</td>
                                            <td className="nowrap text-center">{data?.subcategory?.name || "N/A"}</td>
                                            <td className="nowrap text-center">
                                                <div className="button-container">
                                                    {/* status change button */}

                                                    <button
                                                        type="button"
                                                        onClick={() => handleChangeStatus(data)}
                                                    >
                                                        {data?.status === "ACTIVE" ? (
                                                            <FaToggleOn size={18} />
                                                        ) : (
                                                            <FaToggleOff size={18} />
                                                        )}
                                                    </button>

                                                    {/* ---edit button */}

                                                    <button
                                                        type="button"
                                                        onClick={() => handleUpdateCategory(data, 'Update')}
                                                    >
                                                        <FaEdit />
                                                    </button>

                                                    {/* ----delete Button */}

                                                    <button
                                                        type="button"
                                                        onClick={() => handleDeleteModal(data)}
                                                    >
                                                        <FaRegTrashAlt />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <NotFound
                                    cols={7}
                                    msg={"Filter Category data not found"}
                                    onHide={onHide}
                                />
                            )}
                        </tbody>
                    </table>
                </div>
                {/* -------Add-Update----------- */}
                <UpdateSubSubCategory
                    show={categoryModal?.modal}
                    close={() => setCategoryModal({ modal: false })}
                    data={categoryModal}
                    listing={fetchSubSubCategory}
                />
                {/* -------change-status----------- */}
                <ChangeStatusSubSubCategory
                    show={changeStatusModal?.modal}
                    close={() => setChangeStatusModal({ modal: false })}
                    data={changeStatusModal}
                    setState={setSubSubCategory}
                />
                {/* -------change-status----------- */}
                <DeleteSubSubCategory
                    show={deleteModal?.modal}
                    close={() => setDeleteModal({ modal: false })}
                    data={deleteModal}
                    setState={setSubSubCategory}
                />
                {/* ------Pagination----------- */}
                {total > limit && (
                    <div className="pagination-wrapper">
                        <div className="Pagination">
                            <Pagination
                                activePage={activePage}
                                previousLabel={"previous"}
                                nextLabel={"next"}
                                itemsCountPerPage={limit}
                                totalItemsCount={total}
                                pageRangeDisplayed={5}
                                onChange={handlePageChange}
                                hideDisabled={true}
                            />
                        </div>
                    </div>
                )}
            </div>
        </>

    )
}

export default SubSubCategoryList